import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";

import { userApi } from "@shared/api";

export const kycTokenOptions = () =>
  queryOptions({
    queryFn: () => userApi.postApiV1AccountsMyVerificationGetToken(),
    queryKey: ["get-kyc-token"],
  });

export const useKycToken = () => {
  const { data, error, refetch, isPending } =
    useSuspenseQuery(kycTokenOptions());

  return {
    data: data.data.token,
    error,
    refetch,
    isPending,
  };
};
